"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = void 0;

var _react = _interopRequireDefault(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon-loader");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FaqItem = _interopRequireWildcard(require("./FaqItem"));

require("./Faqs.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'Faqs';
exports.COMPONENT_NAME = COMPONENT_NAME;

const Faqs = ({
  openAllQuestions,
  title,
  titleOptions,
  questions,
  faqItemOptions,
  variant,
  SvgIconLoader,
  taggingInfo
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: "faqs",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
      text: title,
      kind: _gerenciatdUnifiedcomponents.KIND_TEXT.HEADING,
      align: titleOptions.align,
      color: titleOptions.color,
      size: titleOptions.size,
      fontType: titleOptions.fontType,
      className: `${titleOptions.className} faqs__title`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      children: questions.map((eachQuestion, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaqItem.default, {
        isOpen: openAllQuestions,
        faqTitle: eachQuestion.title,
        faqContent: eachQuestion.content,
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentProduct: taggingInfo.componentProduct || '',
          componentVariation: taggingInfo.componentVariation || 'all',
          componentName: COMPONENT_NAME
        }),
        options: faqItemOptions,
        variant: variant,
        SvgIconLoader: SvgIconLoader
      }, `faq-${eachQuestion.title}-${index}`))
    })]
  });
};

var _default = Faqs;
exports.default = _default;
Faqs.defaultProps = {
  openAllQuestions: null,
  titleOptions: {
    align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
    color: _gerenciatdUnifiedcomponents.COLOR.BLACK,
    size: _gerenciatdUnifiedcomponents.SIZE.TITLE2,
    fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.LIGHT,
    className: ''
  },
  faqItemOptions: {
    default: {
      color: {
        title: _gerenciatdUnifiedcomponents.COLOR.GREY_5,
        icon: _gerenciatdUnifiedicons.COLOR.GREY_7
      }
    },
    activated: {
      color: {
        title: _gerenciatdUnifiedcomponents.COLOR.BLUE,
        icon: _gerenciatdUnifiedicons.COLOR.BLUE
      }
    }
  },
  variant: _FaqItem.VARIANT.DEFAULT,
  taggingInfo: {}
};
Faqs.propTypes = {
  /**
   * {
   * "info": "Booleano que nos permite abrir todas las preguntas por defecto",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  openAllQuestions: _propTypes.default.bool,

  /**
   * {
   * "info": "Titulo que aparece para la lista de las preguntas frecuentes/faqs",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  title: _propTypes.default.string.isRequired,

  /**
   * {
   * "info": "Opciones para modificar los estilos de "title"",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  titleOptions: _propTypes.default.shape({
    align: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.ALIGN)),
    color: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.COLOR)),
    size: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.SIZE)),
    fontType: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.FONT_TYPE)),
    className: _propTypes.default.string
  }),

  /**
   * {
   * "info": "Listado de preguntas frecuentes/faqs",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    content: _propTypes.default.string.isRequired
  }).isRequired).isRequired,

  /**
   * {
   * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqItemOptions: _propTypes.default.shape({
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está sin abrir",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    default: _propTypes.default.shape({
      color: _propTypes.default.shape({
        title: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.COLOR)),
        icon: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedicons.COLOR))
      })
    }),

    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está abierta",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    activated: _propTypes.default.shape({
      color: _propTypes.default.shape({
        title: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.COLOR)),
        icon: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedicons.COLOR))
      })
    })
  }),

  /**
   * {
   * "info": "Dependiendo del tipo de "variant" se cambian los estilos de cada pregunta frecuente/faq. Es un modificador",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  variant: _propTypes.default.oneOf(Object.values(_FaqItem.VARIANT)),
  SvgIconLoader: _propTypes.default.func.isRequired,
  taggingInfo: _propTypes.default.object
};

//# sourceMappingURL=index.js.map